export default __webpack_public_path__ + "static/media/507.e87fcbf8.jpg";